import { useContext } from "react";
import { GlobalContext } from "@/helpers/contexts/contexts";
import { ROLES } from "@/helpers/routes/rolesConfig";

const useIsParticipant = () => {
  const { loggedInUserRole } = useContext(GlobalContext);
  return ROLES.PARTICIPANT.includes(loggedInUserRole);
};

export default useIsParticipant;
